import { FamilyTreeActionFn, OpenSidePanelAction } from '../types';

export const openSidePanelAction: FamilyTreeActionFn<OpenSidePanelAction> = (
  state,
  { personId, variant = 'linked', history }
) => {
  return {
    ...state,
    selectedPersonId: personId,
    isSidePanelOpen: true,
    sidePanelVariant: variant,
    sidePanelHistory: history,
  };
};
